import { render, staticRenderFns } from "./StatsSales.vue?vue&type=template&id=32180d00&"
import script from "./StatsSales.vue?vue&type=script&lang=js&"
export * from "./StatsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports